import React from "react";
import GeneralConfigDrawer from "components/GeneralConfig/GeneralConfigDrawer";

/**
 * Abre el drawer de "Configuración general" usando el sistema de modales Redux.
 *
 * @param {(modalProps: object, modalType: string) => void} showModal
 *   Dispatcher de showModal tal y como se expone en mapDispatchToProps
 *   (recibe modalProps y el tipo de modal).
 */
export const openGeneralConfigDrawer = (showModal) => {
	if (typeof showModal !== "function") return;
	showModal(
		{
			open: true,
			width: 640,
			content: ({ close }) => <GeneralConfigDrawer handleClose={close} />,
		},
		"drawer"
	);
};

export default openGeneralConfigDrawer;
